import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { switchToLevel } from "../ai-first/helpers";
import { text } from "@quickpoint.me/shared";

const ariaLive: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.a11yScreenReaderHeading}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: ".chat-codemirror",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yChatAnnounce}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(1);
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yEditorAnnounce}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(3);
		},
	},
];

export default ariaLive;
